const aboutNames = {
    bulgarian: "Виан, Ралица, Илияна, Стефания, Мирослава",
    english: "Vian, Ralitsa, Iliyana, Stefania, Miroslava",
    german: "Vian, Ralitsa, Iliyana, Stefania, Miroslava",
};
export default aboutNames;
